import React from 'react';
import {
  ApButtonGroup,
  ApButtonDanger,
  ApButtonSecondary,
  colors,
} from '@alixpartners/ui-components';
import { SpendTypeEnum } from 'components/Classification';
import { LABELS } from '../SpendTypeSwitch';
import { StyledModal, StyledIcon, TextContent } from './DeleteAllModal.styles';

interface IProps {
  isOpen: boolean;
  isDisabled?: boolean;
  onDelete(): void;
  onClose(): void;
  spendType: SpendTypeEnum;
}

export const DeleteAllModal: React.FC<IProps> = ({
  isOpen,
  isDisabled,
  onDelete,
  onClose,
  spendType,
}) => {
  return (
    <StyledModal
      isOpen={isOpen}
      header={`Delete all ${LABELS[spendType]} rules`}
      isDismissible
      hasClosed={onClose}
      footer={() => {
        return (
          <ApButtonGroup justifyContent="flex-end">
            <ApButtonSecondary onClick={onClose}>Cancel</ApButtonSecondary>
            <ApButtonDanger onClick={onDelete} disabled={isDisabled}>
              {`Delete all ${LABELS[spendType]} rules`}
            </ApButtonDanger>
          </ApButtonGroup>
        );
      }}
    >
      <TextContent>
        <StyledIcon
          iconName="outline_warning"
          iconSize={80}
          iconColor={colors.red1}
        />
        Are you sure you want to delete all {LABELS[spendType]} rules from the
        application?
        <br />
        <b>This action cannot be undone</b>
      </TextContent>
    </StyledModal>
  );
};
